export const PROJECT_LIST = "/api/project/all/list";
export const PROJECT_INVENTORY = "/api/project/inventory/list";
export const PROJECT_DETAIL = "/api/view/project/details";
export const PROJECT_DETAILS = "/api/project/find/details";
export const PROJECT_NAME_CHANGE = "/api/project/rename";
export const PROJECT_DELETE = "/api/project/delete";
export const PROJECT_CLONE = "/api/project/clone";
export const PROJECT_SHARE_LIST = "/api/project/share/user/list";
export const PROJECT_SHARE = "/api/project/share";
export const PROJECT_PUBLISH = "/api/project/publish/v2";
export const PROJECT_STATUS = "/api/project/publish/status";

export const SCENE_DETAIL = "/api/view/project/scene";
export const SCENE_LIST = "/api/project/scene/hierarchy/list";
export const SCENE_LIST_HIERARCHY = "/api/project/scene/hierarchy/list";
export const SCENE_CLONE = "/api/scene/clone";
export const SCENE_SET_DEFAULT = "/api/scene/set/default";
export const SCENE_DELETE = "/api/scene/delete";
export const SCENE_DETAILS = "/api/scene/details";
export const SCENE_DETAILS_UPDATE = "/api/scene/update/details";
export const SCENE_CREATE = "/api/scene/create/new";

export const INVENTORY_SAVE = "/api/inventory/save";

export const HOTSPOT_DELETE = "/api/hotspot/delete";
export const HOTSPOT_DETAILS = "/api/hotspot/details";
export const HOTSPOT_CREATE = "/api/hotspot/create/new";

export const INVENTORY_THUMBNAIL_GENERATE = "/api/inventory/thumbnail/generate";


export const TEAM_DASHBOARD_STATS = "/api/dashboard/team";
export const TEAM_DASHBOARD_GRAPH = "/api/dashboard/team/graph";

export const GROUP_CHILDREN_USERS = "/api/group/all/children/users";
export const GROUP_CHILDREN_HIERARCHY = "/api/group/all/children/hierarchy";
export const GROUP_CHILDREN_LIST = "/api/group/all/children/list";

export const PROJECT_ACCESS ="/api/project/details/access" 

//UNO DETAILS ROUTES START
export const GROUP_LIST = "/api/group/sub-groups/list";
export const GET_GROUP_USER_FROM_UNO = "/api/group/users/list";
export const GET_GROUP_DETAILS_FROM_UNO = "/api/user/group/details";
export const GET_USER_DETAILS_FROM_UNO = "/api/user/details";
//UNO DETAILS ROUTES END